 export const ViewStaffsSkeletonLoader = ({ rows = 5 }: { rows?: number }) => {
    return (
        <div className="animate-pulse space-y-6">
          {/* Search and Filter Bar */}
          <div className="flex justify-between items-center gap-6">
            {/* Search Input */}
            <div className="flex-grow h-10 bg-gray-300 rounded-md"></div>
            {/* Filter Dropdown */}
            <div className="w-20 h-10 bg-gray-300 rounded-md"></div>
          </div>
    
          {/* Table Header */}
          <div className="grid grid-cols-5 gap-4 border-b pb-4">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="h-6 bg-gray-300 rounded-md"></div>
            ))}
          </div>
    
          {/* Table Rows */}
          <div className="space-y-4">
            {Array.from({ length: 5 }).map((_, rowIndex) => (
              <div
                key={rowIndex}
                className="grid grid-cols-5 gap-4 items-center h-10 bg-gray-100 rounded-md"
              >
                {Array.from({ length: 5 }).map((_, colIndex) => (
                  <div
                    key={colIndex}
                    className="h-6 bg-gray-300 rounded-md"
                  ></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      );
  };
  